import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  copyLink(event) {
    const url = event.target.href;

    if (typeof ClipboardItem !== "undefined" && navigator.clipboard.write) {
      const link = new ClipboardItem({
        "text/plain": this.fetchLinkText(url).then(
          (text) => new Blob([text], { type: "text/plain" }),
        ),
      });

      navigator.clipboard
        .write([link])
        .then(() => this.showCopiedMessage())
        .catch(() => this.showErrorMessage());
    } else {
      this.fetchLinkText(url)
        .then((text) => navigator.clipboard.writeText(text))
        .then(() => this.showCopiedMessage())
        .catch(() => this.showErrorMessage());
    }
  }

  async fetchLinkText(url) {
    const response = await fetch(url, { method: "POST" });
    const json = await response.json();
    const text = json.text || json.link;

    if (!response.ok || !text) throw new Error(json.error || response.statusText);

    return text;
  }

  showErrorMessage() {
    const notification = document.getElementById(
      "copy-notification-error-message"
    );
    notification.classList.remove("hidden");

    setTimeout(() => {
      notification.classList.add("hidden");
    }, 3000);
  }

  showCopiedMessage() {
    const notification = document.getElementById("copy-notification-message");
    notification.classList.remove("hidden");

    setTimeout(() => {
      notification.classList.add("hidden");
    }, 3000);
  }
}
